import $ from "jquery";
import "./../styles/main.scss";
import Siema from 'siema';
import Rellax from "rellax";
// require("./helpers/ihavecookies");
import inView from "inview";
require("animate.css");
require("jquery.scrollto");
import Glightbox from "glightbox";
require("./CookieConsent");
$(document).ready(function () {
    if ($('.siema').length) {
        var siema_1 = new Siema({
            loop: true,
            perPage: {
                540: 1,
                800: 2,
                1240: 3
            }
        });
        $('.controls').on("click", "a", function (e) {
            e.preventDefault();
            if ($(e.currentTarget).hasClass("left"))
                siema_1.prev();
            else if ($(e.currentTarget).hasClass("right"))
                siema_1.next();
        });
    }
    var gallery = Glightbox({});
    $("a.customglightbox").on("click", function (e) {
        e.preventDefault();
        gallery.setElements(galleries[$(e.currentTarget).attr("data-gallery")]);
        gallery.open();
    });
    // inView.offset(100);
    // inView('*[data-appear]')
    // .on('enter', el => {
    //     let $this = $(el);
    //     if ($this.attr('data-appearlater') === void 0) {
    //         // $this.addClass('fast animated '+$this.attr('data-appear'));
    //         setTimeout(function(){
    //             $this.addClass('faster animated '+$this.attr('data-appear'));
    //         }, $this.attr('data-appeartiming') !== void 0 ? parseInt($this.attr('data-appeartiming')) : 0 );
    //     }
    // });
    $('*[data-appear]').each(function (k, e) {
        var inview = inView(e, function (isInView, data) {
            if (isInView) {
                if (data.elementOffsetTopInViewHeight < data.inViewHeight / 2) {
                    var $this_1 = $(e);
                    if ($this_1.attr('data-appearlater') === void 0) {
                        setTimeout(function () {
                            $this_1.addClass('animate__faster animate__animated animate__' + $this_1.attr('data-appear'));
                        }, $this_1.attr('data-appeartiming') !== void 0 ? parseInt($this_1.attr('data-appeartiming')) : 0);
                    }
                }
            }
            else { }
        });
    });
    $('.ono').each(function (k, e) {
        var inview = inView(e, function (isInView, data) {
            if (isInView) {
                if (data.elementOffsetTopInViewHeight < data.inViewHeight / 2) {
                    var $this_2 = $(e);
                    setTimeout(function () {
                        $this_2.addClass('showed');
                    }, 500);
                }
            }
            else { }
        });
    });
    $('*[data-appearlater]').each(function (i, e) {
        var $this = $(e);
        setTimeout(function () {
            $this.addClass('animate__faster animate__animated animate__' + $this.attr('data-appear'));
        }, 200 * i);
    });
    $(window).scroll(function () {
        if ($(window).scrollTop() > 100) {
            $('body').removeClass('revert');
        }
        if ($(window).scrollTop() < 100) {
            $('body').addClass('revert');
        }
    });
    if ($('.rellax').length) {
        if ($(window).width() > 600) {
            var rellax = new Rellax('.rellax', {
                // speed: -2,
                center: true
                // center: false
            });
        }
    }
    $("body").on("focus", ".form-group input, .form-group textarea, .form-group select", function (e) {
        $(e.currentTarget).parents('.form-group').addClass("active");
    });
    $("body").on("blur", ".form-group input, .form-group textarea, .form-group select", function (e) {
        var parent = $(e.currentTarget).parents('.form-group');
        parent.removeClass("active");
        if ($(e.currentTarget).val() != "")
            parent.addClass("completed");
        else
            parent.removeClass("completed");
    });
    if ($(".caldera-grid").length) {
        $(".form-group").find(".form-control").trigger("blur");
    }
    $('body').on("change", ".form-group .checkbox input, .form-group .checkbox-inline input", function (e) {
        if ($(e.currentTarget).is(":checked")) {
            $(e.currentTarget).parent(('label')).addClass("checked");
        }
        else {
            $(e.currentTarget).parent(('label')).removeClass("checked");
        }
    });
    if ($('.form-group .checkbox, .form-group .checkbox-inline').length) {
        if ($('.form-group .checkbox, .form-group .checkbox-inline').is(":checked")) {
            $('.form-group .checkbox, .form-group .checkbox-inline').addClass("checked");
        }
    }
    $("body").on("click", "a[href^='#goto-']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("goto-", "");
        var posY = $(node).offset().top - 100;
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
});
